import { render, staticRenderFns } from "./RevenueStatistics.vue?vue&type=template&id=3b226fa2&scoped=true"
import script from "./RevenueStatistics.vue?vue&type=script&lang=js"
export * from "./RevenueStatistics.vue?vue&type=script&lang=js"
import style0 from "./RevenueStatistics.vue?vue&type=style&index=0&id=3b226fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b226fa2",
  null
  
)

export default component.exports